import { apiGet, apiPost, apiPut, apiDelete } from './api'
import type { System, SystemCreate, SystemUpdate } from '../types'

export const systemApi = {
  getTree(projectId: string): Promise<System[]> {
    return apiGet<System[]>(`/systems/project/${projectId}`)
  },

  getById(id: string): Promise<System> {
    return apiGet<System>(`/systems/${id}`)
  },

  create(data: SystemCreate): Promise<System> {
    return apiPost<System>('/systems', data)
  },

  update(id: string, data: SystemUpdate): Promise<System> {
    return apiPut<System>(`/systems/${id}`, data)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/systems/${id}`)
  },
}
